import { Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export function LanguageSwitch() {
  const { language, setLanguage } = useLanguage();
  return (
    <button
      type="button"
      onClick={() => setLanguage(language === 'de' ? 'en' : 'de')}
      className="flex items-center gap-1.5 px-2 py-1.5 rounded-md text-xs md:text-sm transition-colors hover:opacity-80"
      style={{ color: 'rgb(100, 130, 160)', border: '1px solid rgba(169, 201, 232, 0.3)' }}
      title={language === 'de' ? 'Switch to English' : 'Zu Deutsch wechseln'}
    >
      <Globe className="w-3.5 h-3.5" />
      <span>{language === 'de' ? 'EN' : 'DE'}</span>
    </button>
  );
}
